var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "pictureDescription"
    }
  }, [_c("div", {
    staticStyle: {
      height: "24px",
      "background-color": "#f0f2f5"
    }
  }), true ? _c("a-alert", {
    attrs: {
      message: _vm.$t("productDetail.hint"),
      type: "warning",
      "show-icon": "",
      closable: ""
    }
  }, [_c("template", {
    slot: "description"
  }, [_c("span", {
    domProps: {
      innerHTML: _vm._s(_vm.$t("productDetail.publicPicOrSpecPic", {
        uploadLimit: _vm.uploadLimit
      }))
    }
  })])], 2) : _vm._e(), _c("div", {
    staticStyle: {
      height: "24px",
      "background-color": "#f0f2f5"
    }
  }), _c("a-form-model", {
    ref: "dataForm",
    attrs: {
      model: _vm.dataForm
    }
  }, [_c("div", {
    staticClass: "specImageList",
    staticStyle: {
      "padding-bottom": "24px"
    }
  }, _vm._l(_vm.dataForm.specImageList, function (item, index) {
    return _c("a-card", {
      key: "specImageList" + index,
      staticClass: "card",
      attrs: {
        bordered: false
      }
    }, [_vm.dataForm.specFlag == 2 ? _c("span", {
      attrs: {
        slot: "title"
      },
      slot: "title"
    }, [_c("span", {
      staticStyle: {
        color: "#f5222d"
      }
    }, [_vm._v("*")]), _vm._v(" " + _vm._s(_vm.$t("productDetail.productPicture")) + " "), _c("a-tooltip", [_c("template", {
      slot: "title"
    }, [_vm._v(" " + _vm._s(_vm.$t("productDetail.productPicturePrompt")) + " ")]), _c("a-icon", {
      attrs: {
        type: "info-circle"
      }
    })], 2)], 1) : _vm._e(), _vm.dataForm.specFlag != 2 && index == 0 ? _c("span", {
      attrs: {
        slot: "title"
      },
      slot: "title"
    }, [_vm._v(" " + _vm._s(_vm.$t("productDetail.publicPicture")) + " "), _c("a-tooltip", [_c("template", {
      slot: "title"
    }, [_vm._v(" " + _vm._s(_vm.$t("productDetail.publicPicturePrompt")) + " ")]), _c("a-icon", {
      attrs: {
        type: "info-circle"
      }
    })], 2)], 1) : _vm._e(), _vm.dataForm.specFlag != 2 && index != 0 ? _c("span", {
      attrs: {
        slot: "title"
      },
      slot: "title"
    }, [_vm._v(" " + _vm._s(item.specValueName) + " "), _c("a-tooltip", [_c("template", {
      slot: "title"
    }, [_vm._v(" " + _vm._s(_vm.$t("productDetail.productPicturePrompt")) + " ")]), _c("a-icon", {
      attrs: {
        type: "info-circle"
      }
    })], 2)], 1) : _vm._e(), _c("div", {
      staticClass: "myFileList",
      staticStyle: {
        display: "flex",
        width: "100%"
      }
    }, [_c("a-upload", {
      staticClass: "upload-list-inline",
      attrs: {
        "before-upload": _vm.beforeUpload,
        listType: "picture-card",
        showUploadList: false,
        multiple: false,
        customRequest: function customRequest(_ref) {
          var action = _ref.action,
            file = _ref.file,
            onSuccess = _ref.onSuccess,
            onError = _ref.onError,
            onProgress = _ref.onProgress;
          return _vm.handleUploadChange({
            action: action,
            file: file,
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress
          }, index);
        }
      },
      on: {
        change: _vm.handleChange
      }
    }, [item.imageList.length < 8 ? _c("div", [_c("a-icon", {
      attrs: {
        type: _vm.Uploading && _vm.uploadIndex == index ? "loading" : "plus"
      }
    }), _c("div", {
      staticClass: "ant-upload-text"
    }, [_vm._v(_vm._s(_vm.$t("public.uploadPicture")))])], 1) : _vm._e()]), _c("a-modal", {
      attrs: {
        visible: _vm.previewVisible,
        footer: null,
        maskClosable: false
      },
      on: {
        cancel: _vm.handleCancel
      }
    }, [_c("img", {
      staticStyle: {
        width: "100%"
      },
      attrs: {
        alt: "example",
        src: _vm.previewImage
      }
    })]), item.imageList.length > 0 ? _c("div", {
      staticStyle: {
        width: "100%"
      }
    }, [_c("draggable", {
      staticClass: "syllable_ul",
      attrs: {
        element: "ul",
        list: item.imageList,
        options: {
          group: "productImage",
          animation: 150
        },
        "no-transition-on-drag": true
      }
    }, [_c("transition-group", {
      attrs: {
        type: "transition",
        css: true
      }
    }, _vm._l(item.imageList, function (image, index2) {
      return image.productImage ? _c("div", {
        key: "imageList" + index2,
        staticClass: "fileList",
        staticStyle: {
          width: "104px",
          height: "104px",
          display: "inline-block",
          margin: "0 8px 8px 0",
          padding: "8px",
          border: "1px solid #d9d9d9",
          "border-radius": "2px"
        }
      }, [_c("div", {
        staticClass: "imgStyle price"
      }, [_c("span", {
        staticClass: "content"
      }, [_c("a", {
        attrs: {
          href: _vm.dataForm.host + image.productImage,
          target: "_blank"
        }
      }, [_c("img", {
        staticStyle: {
          width: "100%",
          height: "100%"
        },
        attrs: {
          src: _vm.dataForm.host + image.productImage,
          alt: "image.png"
        }
      })]), _c("a", {
        attrs: {
          target: "_blank",
          href: _vm.dataForm.host + image.image
        }
      })])]), _c("span", [_c("a-icon", {
        staticClass: "anticon-eye-o",
        attrs: {
          type: "eye"
        },
        on: {
          click: function click($event) {
            return _vm.handlePreview(image);
          }
        }
      }), _c("a-icon", {
        staticClass: "anticon-delete",
        attrs: {
          type: "delete"
        },
        on: {
          click: function click(data) {
            return _vm.handleDelete(data, image, index);
          }
        }
      })], 1)]) : _vm._e();
    }), 0)], 1)], 1) : _vm._e()], 1)]);
  }), 1), _c("footer-tool-bar", [_c("a-button", {
    attrs: {
      loading: _vm.queryLoading,
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t("public.save")))])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };